import { render } from "./newsEdit.vue?vue&type=template&id=254273ea&scoped=true"
import script from "./newsEdit.vue?vue&type=script&lang=js"
export * from "./newsEdit.vue?vue&type=script&lang=js"

import "./newsEdit.vue?vue&type=style&index=0&id=254273ea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254273ea"],['__file',"src/views/website/newsEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "254273ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('254273ea', __exports__)) {
    console.log('reload')
    api.reload('254273ea', __exports__)
  }
  
  module.hot.accept("./newsEdit.vue?vue&type=template&id=254273ea&scoped=true", () => {
    console.log('re-render')
    api.rerender('254273ea', render)
  })

}


export default __exports__